const e = import.meta.env;

const env = {
  REACT_APP_API_ENDPOINT: e.REACT_APP_API_ENDPOINT,
  REACT_APP_S3_BUCKET_PRESIGN_URL: e.REACT_APP_S3_BUCKET_PRESIGN_URL,
  REACT_APP_IS_ENABLE_TRANS_DEBUG: !!e.REACT_APP_IS_ENABLE_TRANS_DEBUG,
  REACT_APP_LA_DOMAIN: e.REACT_APP_LA_DOMAIN,

  IS_DEV: !e.REACT_APP_DEPLOY_ENV || e.REACT_APP_DEPLOY_ENV === 'dev',
  // Only REACT_APP_* reaches the bundle (as under CRA), so this stays undefined in the browser.
  PORT: e.PORT
};

export const { REACT_APP_API_ENDPOINT, REACT_APP_S3_BUCKET_PRESIGN_URL, REACT_APP_IS_ENABLE_TRANS_DEBUG, REACT_APP_LA_DOMAIN, IS_DEV, PORT } = env;

export default env;
